import { AwsRum } from 'aws-rum-web'
import { RUM_APPLICATION_ID } from './constants'
import url from './services/url'
import { fetchUsageMonitorConfig } from './api/usage-monitor'

let awsRum
let configCache = null

const getAwsRegion = () => {
  const env = url.getCustomerEnvironment()
  return env === 'staging' ? 'us-west-2' : 'us-east-2'
}

const getAwsRum = async () => {
  if (!awsRum) awsRum = await init()
  return awsRum
}

const init = async () => {
  try {
    // Fetch configuration from backend
    if (!configCache) {
      configCache = await fetchUsageMonitorConfig()
    }

    // Remove user_identifier before passing to AwsRum
    const { endpoint, applicationId, region, user_identifier, ...rest } =
      configCache

    const config = {
      sessionSampleRate: 1,
      endpoint: endpoint,
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: false,
      signing: false,
      ...rest,
    }

    const APPLICATION_VERSION = '1.0.0'
    return new AwsRum(applicationId, APPLICATION_VERSION, region, config)
  } catch (error) {
    console.error('CloudWatch RUM init failed:', error)
  }
}

export const addPageAttribute = (attributeObject) => {
  getAwsRum()
    .then((rumInstance) => {
      if (!attributeObject) attributeObject = {}
      rumInstance?.addSessionAttributes?.(attributeObject)
    })
    .catch((error) => {
      console.warn('Failed to add page attribute:', error)
    })
}

export const removePageAttribute = (attributeKey) => {
  getAwsRum()
    .then((rumInstance) => {
      if (!attributeKey) attributeKey = ''
      rumInstance?.removeSessionAttributes?.([attributeKey])
    })
    .catch((error) => {
      console.warn('Failed to remove page attribute:', error)
    })
}

export const dispatchEvent = (eventName, eventData) => {
  if (!eventData) eventData = {}
  getAwsRum()
    .then((rumInstance) => {
      rumInstance?.recordEvent?.(eventName, eventData)
    })
    .catch((error) => {
      console.warn('Failed to dispatch event:', error)
    })
}
